export default "__VITE_ASSET__DODya9Mt__"